export enum TypeFilter {
  uid = 1,
  global = 2,
  pairingField = 3,
  area = 4,
  dateRange = 5,
  expired = 6,
  triggerType = 7,
  trigger = 8,
}

export interface BaseFilterData<T> {
  value: T
  id?: string
  type?: TypeFilter
  // rangeValue?: RangeData
  // id?: string
  // displayName?: string
  // pairingFieldId?: string
  // pairingFieldName?: string
}

abstract class BaseFilter<T> {
  _id!: string
  _displayName!: string
  _type!: TypeFilter

  private _value: T

  public get id(): string {
    return this._id
  }

  public get type(): TypeFilter {
    return this._type
  }

  public get value(): T {
    return this._value
  }

  public get displayName(): string {
    return this._displayName
  }

  constructor(data: BaseFilterData<T>) {
    this._value = data.value
  }
}

export class FilterUid extends BaseFilter<string> {
  constructor(data: BaseFilterData<string>) {
    super(data)
    this._type = TypeFilter.uid
    this._id = data.id ?? `${data.type}_${data.value}`
    this._displayName = `#${data.value}`
  }
}
